import { useTranslation } from "react-i18next";
import { MobileCardRow, MobileCardWrapper, TableBody, TableColumn, TableHeader, TableRow, TableCell } from "./dashboard/table-components";
import { useMediaQuery } from '@mui/material';
import { formatDate } from '../helper/common.helper';
import { useStatements } from '../hooks/useStatements';
import { YearFilter } from './common/YearFilter';
import './../scss/components/invoice-table-detailed.style.scss';
import { DownloadIcon } from "../assets/dashboard-icon.svg";

export const StatementsInvoiceSection = () => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const {
        statements,
        loading,
        error,
        handleYearChange,
        selectedYear
    } = useStatements();
    return (
        <>
            <YearFilter
                onYearChange={handleYearChange}
                initialYear={selectedYear}
                label={t('YEAR_LABEL')}
                className="statements-year-filter"
            />
            <div className={`invoice-table-container my-4`}>
                <div className="invoice-table-content">
                    <div className="invoice-table">

                        <>
                            {!isMobile && (
                                <TableHeader>
                                    {[t('SALARY_IN_') + selectedYear, t('TAX_IN_') + selectedYear, t('SOCIAL_FEE_IN_') + selectedYear, t('GROSS_SALARY_INC_HOLIDAY_PAY_IN') + selectedYear].map((header, index) => (
                                        <TableColumn key={index}>{header}</TableColumn>
                                    ))}
                                </TableHeader>
                            )}

                            <TableBody>
                                {statements === null && (
                                    <div className="invoice-table">
                                        <div className="invoice-table-content">
                                            {/* No drafts found message */}
                                            {statements === null && (
                                                <div className='d-flex justify-content-center flex-column align-items-center pt-5'>
                                                    <span className='pt-3'>{t('NO_DATA_FOUND')}.</span>
                                                    {error}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {isMobile ? (
                                    // Mobile: Card-based layout
                                    ([statements].map((value, index) =>
                                        <MobileCardWrapper key={index}>
                                            <MobileCardRow label={t('SALARY_IN_') + selectedYear} >
                                                {value?.salary}
                                            </MobileCardRow>
                                            <MobileCardRow label={t('TAX_IN_') + selectedYear}>
                                                {value?.totalTax}
                                            </MobileCardRow>
                                            <MobileCardRow label={t('SOCIAL_FEE_IN_') + selectedYear}>
                                                {value?.socialFee}
                                            </MobileCardRow>
                                            <MobileCardRow label={t('GROSS_SALARY_INC_HOLIDAY_PAY_IN') + selectedYear}>
                                                {value?.grossSalary}
                                            </MobileCardRow>
                                            {/* <MobileCardRow label={t('ACTION_LABEL')}>
                                                    <DownloadIcon />
                                                </MobileCardRow> */}
                                        </MobileCardWrapper>
                                    ))
                                ) : (
                                    [statements]).map((value, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{value?.salary}</TableCell>
                                            <TableCell>{value?.totalTax}</TableCell>
                                            <TableCell>{value?.socialFee}</TableCell>
                                            <TableCell>{value?.grossSalary}</TableCell>
                                            {/* <TableCell>
                                                    <DownloadIcon />
                                                </TableCell> */}

                                        </TableRow>
                                    ))
                                }

                            </TableBody>
                        </>
                    </div>
                </div>
            </div>
        </>
    )
};